export const pageAndRouteMapping = {
    SIGNUP_SUCCESS: '/site/signup/success',
    SIGNIN: '/site/signin'
}